/* tslint:disable */
/* eslint-disable */

/**
 * 0 = MainlandUK
 * 
 * 1 = International
 */
export enum CarriageLocation {
  MainlandUK = 0,
  International = 1
}
